import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from '../Services/auth.service';

export const entitlementGuard: CanActivateFn = (route) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const requiredEntitlement: string | undefined = route.data?.['entitlement'];

    if (!requiredEntitlement) {
        return true;
    }

    return authService.initializeAuth().pipe(
        map(() => {
            const user = authService.getCurrentUser();

            if (!user?.hasEntitlement(requiredEntitlement)) {
                return router.createUrlTree(['/home']);
            }

            return true;
        })
    );
};
